import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import { colors, fontSize } from '../../constants/styleConstants';

const useStyles = makeStyles(() => ({
  subTitle: {
    fontFamily: 'Roboto, sans-serif',
    fontWeight: 'bold',
    fontSize: 12,
    color: colors.title,
    textTransform: 'uppercase',
    letterSpacing: 3.5,
    textAlign: 'inherit',
    '& *': {
      fontFamily: 'inherit',
      color: 'inherit',
      fontSize: 'inherit',
    },
  },
  pageSubtitle: {
    color: colors.subTitle,
    fontSize: fontSize.basic,
  },
}));

const SubTitle = ({ children, className, type }) => {
  const classes = useStyles();
  return (
    <h2 className={classnames(classes.subTitle, className, { [classes.pageSubtitle]: type === 'page' })}>{children}</h2>
  );
};

SubTitle.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  type: PropTypes.oneOf(['page', 'common']),
};

SubTitle.defaultProps = {
  type: 'page',
};

export default SubTitle;
